import React from 'react'
import { useTranslation } from 'react-i18next'

import { KibButtonWithMenu } from '~/components/common/buttons/KibButtonWithMenu'
import DialogNames from '~/constants/DialogNames'
import {
  PrescriptionDeclineReasonName,
  PrescriptionDeclineReasonType,
} from '~/constants/PrescriptionWorkflow'
import useDialog from '~/utils/useDialog'

import type { PrescriptionActionContextType } from '../../PrescriptionContext'

export interface PrescriptionDeclineActionChirpProps {
  className?: string
  disabled?: boolean
  loading?: boolean
  onDecline: PrescriptionActionContextType['onDecline']
}

const PrescriptionDeclineActionChirp = ({
  className,
  disabled,
  loading,
  onDecline,
}: PrescriptionDeclineActionChirpProps) => {
  const { t } = useTranslation(['Common'])
  const [openDialog] = useDialog(DialogNames.PRESCRIPTION_DECLINE_REASON_CHIRP)

  const handleDecline = (declineReason: string) => {
    const reasonType = declineReason as PrescriptionDeclineReasonType
    if (reasonType === PrescriptionDeclineReasonType.OTHER) {
      openDialog({ onDecline })
    } else {
      onDecline(PrescriptionDeclineReasonName[reasonType])
    }
  }

  return (
    <KibButtonWithMenu
      buttonText={t('Common:DECLINE_ACTION')}
      className={className}
      disabled={disabled}
      loading={loading}
      name="prescription-decline"
      optionsDisplayMap={PrescriptionDeclineReasonName}
      optionsValueMap={PrescriptionDeclineReasonType}
      onSelectOption={handleDecline}
    />
  )
}

export default PrescriptionDeclineActionChirp
